module.exports = __webpack_public_path__ + "static/img/iv-1.229c99b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/iv/iv-1.png
// module id = bkDb
// module chunks = 1